module.exports = __webpack_public_path__ + "img/Frame4250.589fc390.png";